import { render, staticRenderFns } from "./Cates.vue?vue&type=template&id=c7690f2a&scoped=true&"
import script from "./Cates.vue?vue&type=script&lang=js&"
export * from "./Cates.vue?vue&type=script&lang=js&"
import style0 from "./Cates.vue?vue&type=style&index=0&id=c7690f2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7690f2a",
  null
  
)

export default component.exports